import AdobeLaunchFormMappings from './AdobeLaunch/Form/index.js';
import ShiftFormMappings from './Shift/Form/index';
import ShiftPageAliasMappings from './Shift/PageAlias/index';
import AdobeLaunchPageAliasMappings from './AdobeLaunch/PageAlias/index';
import GTMEvents from './AdobeLaunch/GTM/index';

const {
	PageAliasMapping,
	GMPageAliasMapping,
	NissanPageAliasMapping
} = AdobeLaunchPageAliasMappings;

const { NissanGTMMapping, GTMMapping } = GTMEvents;

const {
	FormTrackingIdMapping,
	NissanFormTrackingIdMapping,
	GMFormTrackingIdMapping
} = AdobeLaunchFormMappings;

const {
	ShiftPageAliasMapping,
	BmwPageAliasMapping,
	KiaPageAliasMapping,
	LexusPageAliasMapping,
	MaseratiPageAliasMapping,
	MazdaPageAliasMapping,
	PorschePageAliasMapping,
	ToyotaPageAliasMapping,
	VwPageAliasMapping
} = ShiftPageAliasMappings;

const {
	ShiftFormTrackingIdMapping,
	MaseratiFormTrackingIdMapping
} = ShiftFormMappings;

export const mappings = {
	adobe_launch: {
		nissan: {
			pageAlias: { ...PageAliasMapping, ...NissanPageAliasMapping },
			form: { ...FormTrackingIdMapping, ...NissanFormTrackingIdMapping },
			gtm: { ...NissanGTMMapping, ...GTMMapping }
		},
		gm: {
			pageAlias: { ...PageAliasMapping, ...GMPageAliasMapping },
			form: { ...FormTrackingIdMapping, ...GMFormTrackingIdMapping },
			gtm: { GTMMapping }
		},
		default: {
			pageAlias: { ...PageAliasMapping },
			form: { ...FormTrackingIdMapping },
			gtm: { ...GTMMapping }
		}
	},
	conversant: {
		default: {
			pageAlias: { ...PageAliasMapping },
			form: { ...FormTrackingIdMapping },
			gtm: { ...GTMMapping }
		}
	},
	shift: {
		default: {
			pageAlias: { ...ShiftPageAliasMapping },
			form: { ...ShiftFormTrackingIdMapping }
		},
		bmw: {
			pageAlias: { ...ShiftPageAliasMapping, ...BmwPageAliasMapping },
			form: { ...ShiftFormTrackingIdMapping }
		},
		kia: {
			pageAlias: { ...ShiftPageAliasMapping, ...KiaPageAliasMapping },
			form: { ...ShiftFormTrackingIdMapping }
		},
		lexus: {
			pageAlias: { ...ShiftPageAliasMapping, ...LexusPageAliasMapping },
			form: { ...ShiftFormTrackingIdMapping }
		},
		maserati: {
			pageAlias: {
				...ShiftPageAliasMapping,
				...MaseratiPageAliasMapping
			},
			form: {
				...ShiftFormTrackingIdMapping,
				...MaseratiFormTrackingIdMapping
			}
		},
		mazda: {
			pageAlias: { ...ShiftPageAliasMapping, ...MazdaPageAliasMapping },
			form: { ...ShiftFormTrackingIdMapping }
		},
		mercedes: {
			pageAlias: { ...ShiftPageAliasMapping },
			form: { ...ShiftFormTrackingIdMapping }
		},
		porsche: {
			pageAlias: { ...ShiftPageAliasMapping, ...PorschePageAliasMapping },
			form: { ...ShiftFormTrackingIdMapping }
		},
		toyota: {
			pageAlias: { ...ShiftPageAliasMapping, ...ToyotaPageAliasMapping },
			form: { ...ShiftFormTrackingIdMapping }
		},
		vw: {
			pageAlias: { ...ShiftPageAliasMapping, ...VwPageAliasMapping },
			form: { ...ShiftFormTrackingIdMapping }
		}
	}
};
